import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { I18nProvider } from "./lib/i18n";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import UseCases from "./pages/UseCases";
import Tasks from "./pages/Tasks";
import TaskDetail from "./pages/TaskDetail";
import Approvals from "./pages/Approvals";
import Registers from "./pages/Registers";
import AuditLog from "./pages/AuditLog";
import UserManager from "./pages/UserManager";
import Files from "./pages/Files";
import Integrations from "./pages/Integrations";
import VoicePage from "./pages/VoicePage";
import BuildPrompt from "./pages/BuildPrompt";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="flex min-h-screen items-center justify-center text-slate-500">…</div>;
  return user ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/use-cases" element={<UseCases />} />
              <Route path="/tasks" element={<Tasks />} />
              <Route path="/tasks/:id" element={<TaskDetail />} />
              <Route path="/approvals" element={<Approvals />} />
              <Route path="/registers/:entity" element={<Registers />} />
              <Route path="/audit" element={<AuditLog />} />
              <Route path="/users" element={<UserManager />} />
              <Route path="/files" element={<Files />} />
              <Route path="/integrations" element={<Integrations />} />
              <Route path="/voice" element={<VoicePage />} />
              <Route path="/build-prompt" element={<BuildPrompt />} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
